export default {
  HEADER: 'header',
  POPUP: 'pop-up',
  FOOTER: 'footer',
  CONTENT_TILE: 'content-tile',
};

export const VIEW_STATE = {
  DEFAULT: 'DEFAULT',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const EVENT_TYPE = {
  VIEW_ANNOUNCEMENT: 'view announcement',
  CLICK_ANNOUNCEMENT: 'click announcement',
  OAI_DONE_CLICK: 'oai-done-click',
};
